<template>
  <el-table-with-pagination
    :data="data.rows"
    :default-sort="{ prop: 'representive', order: 'ascending' }"
    :page-sizes="[10, 50, 100]"
    empty-text="No report!"
    :summary-method="getSummaries"
    @sort-change="sortChange"
    show-summary
    v-if="data.rows.length"
  >
    <template #btn>
      <download-csv
        :data="filterDataRows()"
        :fields="Object.keys(data.headers)"
        :labels="data.headers"
        name="data.csv"
        style="width: 180px"
      >
        <button class="btn btn-report btn-outline-pink">
          Download csv file
        </button>
      </download-csv>
    </template>
    <el-table-column
      v-for="(value, key) in data.headers"
      :key="key"
      :prop="key"
      :label="value"
      :sort-orders="['ascending', 'descending']"
      :formatter="formatter"
      :fixed="['representive', 'creative'].includes(key)"
      :min-width="['creative'].includes(key) ? 400 : 200"
      sortable="custom"
    ></el-table-column>
  </el-table-with-pagination>
</template>

<script>
import ElTableWithPagination from "@/components/base/elTableWithPagination";
import JsonCSV from "vue-json-csv";
export default {
  props: {
    data: { type: Object, default: { headers: [], rows: [] } },
  },
  components: {
    ElTableWithPagination,
    DownloadCsv: JsonCSV,
  },
  methods: {
    sortChange(val) {
      this.data.rows = _.orderBy(this.data.rows, (o) => o[val.prop], [
        val.order === "ascending" ? "asc" : "desc",
      ]);
    },
    filterDataRows() {
      let rows = _.cloneDeep(this.data.rows);
      return rows.map((row) => {
        for (const [key, value] of Object.entries(row)) {
          if (
            typeof value === "string" &&
            value.indexOf("(") !== -1 &&
            value.indexOf("%") !== -1
          ) {
            let eleIndex = value.indexOf("(");
            value = value.slice(0, eleIndex);
          }
          row[key] = value;
        }
        return row;
      });
    },
    getSummaries() {
      const sums = {};
      _.forEach(_.keys(this.data.headers), (col) => {
        if (col === "representive") {
          sums[col] = "Total";
          return;
        }
        if (col === "avg_video_watch_time") {
          let impression_total = 0
          let video_watch_time_total = 0
          _.forEach(this.data.rows, (row) => {
            if (row.impressions) {
              video_watch_time_total += row.video_watch_time
              impression_total += row.impressions
            }
          })
          sums[col] = (video_watch_time_total / impression_total)
          return
        }
        let tmp = 0;
        _.forEach(this.data.rows, (row) => {
          if (!_.isNumber(row[col]) || col === "reach") {
            tmp = "";
            return;
          }
          tmp += row[col];
        });
        sums[col] = tmp;
      });

      return _.map(_.keys(sums), (key) => this.formatter(sums, key));
    },
    formatter(row, col) {
      col = col.property || col;
      if (row[col] === undefined || row[col] === null) {
        return "--";
      } else if (typeof row[col] === "string" || col === "representive") {
        return row[col];
        // } else if (
        //   [].includes(col)
        // ) {
        //   return new Intl.NumberFormat('en-US', {
        //     style: 'currency',
        //     currency: this.$store.state.currency
        //   }).format(row[col])
        // } else if (['CTR'].includes(col)) {
        //   return new Intl.NumberFormat(undefined, {
        //     style: 'percent',
        //     minimumFractionDigits: 2
        //   }).format(row[col])
      } else {
        return new Intl.NumberFormat(undefined, {
            maximumFractionDigits: 2
          }).format(row[col])
      }
    },
  },
};
</script>

<style lang="sass" scoped>
.report-query-container
  border: 1px solid #e6e6e6
  border-radius: 5px
  padding: 15px 25px
</style>
